import { firebaseDatabase } from '../../firebaseDb';

export default {

    state: {
        notify_msg_to_user: '',
        message: []
    },

    getters: {
        getMessage: state => state.message,
        getSendMessageStatus: state => state.notify_msg_to_user
    },

    actions: {

        initMsg(context) {
            context.commit("INITMSG");
        },

        updateStateNotifyMsgToUser(context){
            context.commit("UPDATESTATENOTIFYMSGTOUSER");
        },

        sendMsg(context, msg_schema) {
            // console.log(msg_schema);
            firebaseDatabase.collection('contactform').add(msg_schema)
                .then(()=> {
                    console.log('Success');
                    context.state.notify_msg_to_user = 'Success';
                    context.commit("ADDMSGTOSTORAGE", msg_schema)
                })
                .catch((err) => {
                    console.log('Fail');
                    console.log(err);
                    context.state.notify_msg_to_user = 'Fail' ;
                });
        }
    },
    mutations: {

        INITMSG(state) {
            // localStorage.clear()
            state.message = JSON.parse(localStorage.getItem('shine')) || []
        },

        ADDMSGTOSTORAGE(state, msg_schema) {
            state.message.push(msg_schema);
            localStorage.setItem('shine', JSON.stringify(state.message));
        },

        UPDATESTATENOTIFYMSGTOUSER(state){
            state.notify_msg_to_user = ''
        }
    }
}